import { __rest } from "tslib";
import lodashChunk from 'lodash/chunk';
import lodashKeyBy from 'lodash/keyBy';
import { api } from '@/api/api';
import { apis } from '@/config';
import { edmMailHelper, RoleScoreMap } from '@/api/util/edm_mail_helper';
import { util, wait } from '@/api/util';
import { mailPlusUtilInstance } from './mail_plus_util';
import { MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT, MAIL_PLUS_CUSTOMER_GROUP_FAVORITE, MAIL_PLUS_CUSTOMER_GROUP_MONITOR } from '@/const';
import { getSignByApiParams } from '../../../utils/httpHelper';
const defaultEdmSendMailConflictConfig = [
    {
        module: 0,
        colleagueCustomer: false,
        colleagueClue: false,
    },
    {
        module: 1,
        colleagueCustomer: false,
        colleagueClue: false,
    },
];
class MailPlusCustomer {
    constructor() {
        this.edmRoleApi = api.requireLogicalApi(apis.edmRoleApiImpl);
        this.dataTrackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.mailPlusUtilInstance = mailPlusUtilInstance;
        this.edmSendMailConflictConfig = defaultEdmSendMailConflictConfig;
        this.displayEmailLabelMap = new Map();
        this.latestContactIdList = ['OneDay', 'ThreeDay', 'SevenDay', 'FifteenDay'];
        this.latestContactGroups = {
            OneDay: {
                group_id: 'OneDay',
                group_name: '1天未联系',
                count: 0,
                filter: {
                    relation: 'AND',
                    subs: [
                        {
                            id: 'latest_contact_time',
                            table: 'customer',
                            condition: {
                                type: 'BETWEEN_LAST_N_TO_M_HOUR',
                                method: 'EQUAL',
                                values: [23, 24],
                            },
                        },
                    ],
                },
            },
            ThreeDay: {
                group_id: 'ThreeDay',
                group_name: '1~3天未联系',
                count: 0,
                filter: {
                    relation: 'AND',
                    subs: [
                        {
                            id: 'latest_contact_time',
                            table: 'customer',
                            condition: {
                                type: 'BETWEEN_LAST_N_TO_M_DAY',
                                method: 'EQUAL',
                                values: [1, 3],
                            },
                        },
                    ],
                },
            },
            SevenDay: {
                group_id: 'SevenDay',
                group_name: '3~7天未联系',
                count: 0,
                filter: {
                    relation: 'AND',
                    subs: [
                        {
                            id: 'latest_contact_time',
                            table: 'customer',
                            condition: {
                                type: 'BETWEEN_LAST_N_TO_M_DAY',
                                method: 'EQUAL',
                                values: [3, 7],
                            },
                        },
                    ],
                },
            },
            FifteenDay: {
                group_id: 'FifteenDay',
                group_name: '7~15天未联系',
                count: 0,
                filter: {
                    relation: 'AND',
                    subs: [
                        {
                            id: 'latest_contact_time',
                            table: 'customer',
                            condition: {
                                type: 'BETWEEN_LAST_N_TO_M_DAY',
                                method: 'EQUAL',
                                values: [7, 15],
                            },
                        },
                    ],
                },
            },
        };
        this.groupsFilters = {
            [MAIL_PLUS_CUSTOMER_GROUP_FAVORITE]: {
                relation: 'AND',
                subs: [
                    {
                        id: 'favorite',
                        table: 'customer',
                        condition: {
                            method: 'EQUAL',
                            value: 'true',
                        },
                    },
                ],
            },
            [MAIL_PLUS_CUSTOMER_GROUP_MONITOR]: {
                relation: 'AND',
                subs: [
                    {
                        id: 'monitor',
                        table: 'customer',
                        condition: {
                            method: 'IS_NOT_EMPTY',
                        },
                    },
                ],
            },
        };
        this.name = apis.mailPlusCustomerApiImpl;
        this.systemApi = api.getSystemApi();
        this.httpApi = api.getDataTransApi();
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
    }
    init() {
        return this.name;
    }
    async doGetRoleByEmail(params) {
        var _a;
        const { emails, _account, useLx = true, useEdm = process.env.BUILD_ISEDM || ((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion) } = params;
        if (!emails || emails.length === 0) {
            return {};
        }
        const { emailSet, emailList } = emails.reduce((obj, item) => {
            const email = item === null || item === void 0 ? void 0 : item.toLocaleLowerCase();
            if (email) {
                obj.emailSet.add(email);
                obj.emailList.push(item);
            }
            return obj;
        }, { emailSet: new Set(), emailList: [] });
        const dataMap = new Map();
        if (useLx) {
            await this.getLxContactDataByEmail(dataMap, emailSet, _account);
        }
        if (emailSet.size > 0 && useEdm) {
            await this.getEdmContactDataByEmail(dataMap, emailSet);
        }
        return emailList.reduce((total, _email) => {
            const email = _email === null || _email === void 0 ? void 0 : _email.toLocaleLowerCase();
            const currentData = dataMap.get(email);
            if (currentData && currentData.score > RoleScoreMap.external) {
                total[_email] = currentData.data;
            }
            return total;
        }, {});
    }
    async getLxContactDataByEmail(dataMap, emailSet, _account) {
        const lxData = await this.contactApi.doGetContactByEmail({ emails: [...emailSet], _account });
        Object.keys(lxData).forEach(key => {
            const contactModels = lxData[key];
            contactModels.forEach(({ contact }) => {
                const newData = edmMailHelper.transContactModelToEmailRole(contact, key);
                edmMailHelper.insertIntoDataMap({ dataMap, emailSet, newData, maxScore: RoleScoreMap.enterprise });
            });
        });
        console.log('[doGetRoleByEmail] after lx', dataMap, emailSet);
    }
    async getEdmContactDataByEmail(dataMap, emailSet) {
        if (emailSet.size > 0) {
            const url = this.systemApi.getUrl('getCustomerLabelByEmailNew');
            const { data } = await this.httpApi.post(url, { email_list: [...emailSet] }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && Array.isArray(data.data) && data.data.length > 0) {
                const SCORE_MAP = {
                    4: 'myCustomer',
                    7: 'openSeaCustomer',
                    8: 'colleagueCustomer',
                    9: 'colleagueCustomerNoAuth',
                    1: 'myClue',
                    10: 'colleagueClue',
                    3: 'openSeaClue',
                    11: 'colleagueClueNoAuth',
                };
                data.data.forEach(v => {
                    var _a, _b;
                    let role = SCORE_MAP[v.email_label];
                    if (((_a = this.systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion) && !['myCustomer', 'colleagueCustomer', 'colleagueCustomerNoAuth'].includes(role)) {
                        return;
                    }
                    if (role) {
                        const newData = {
                            role,
                            email: (_b = v.contact_email) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase(),
                            companyId: String(v.id),
                            companyName: v.company_name,
                            leadsName: v.detail_name,
                            contactId: String(v.contact_id),
                            contactName: v.contact_name,
                            customerCreateTime: v.create_time || 0,
                            relatedCompanyInfo: [{ companyId: String(v.id), companyName: String(v.company_name || ''), leadsName: String(v.detail_name || '') }],
                        };
                        edmMailHelper.insertIntoDataMap({ dataMap, emailSet, newData, privilege: this.doGetLastEdmPrivilegeViewData() });
                    }
                });
            }
            console.log('[doGetRoleByEmail] after edm', dataMap, emailSet);
        }
    }
    doCompareContactModelRoles(contactModels) {
        return contactModels.reduce((prev, next) => {
            const prevData = edmMailHelper.transContactModelToEmailRole(prev.contact);
            const nextData = edmMailHelper.transContactModelToEmailRole(next.contact);
            return edmMailHelper.compareRoles(prevData, nextData) > -1 ? prev : next;
        });
    }
    doCompareEmailRoles(dataList) {
        return dataList.reduce((prev, next) => (edmMailHelper.compareRoles(prev, next) > -1 ? prev : next));
    }
    async doGetCustomerDataByIds(companyIdList, updateCustomerIdRoleMap) {
        try {
            if (!Array.isArray(companyIdList) || companyIdList.length === 0) {
                return [];
            }
            let myCompanyIdList = companyIdList;
            let openSeaCompanyIdList = companyIdList;
            let myClueIdList = companyIdList;
            let openSeaClueIdList = companyIdList;
            if (updateCustomerIdRoleMap && Object.keys(updateCustomerIdRoleMap).length) {
                myCompanyIdList = companyIdList.filter(id => !updateCustomerIdRoleMap[id] || ['myCustomer', 'colleagueCustomer', 'colleagueCustomerNoAuth'].includes(updateCustomerIdRoleMap[id]));
                openSeaCompanyIdList = companyIdList.filter(id => !updateCustomerIdRoleMap[id] || ['openSeaCustomer'].includes(updateCustomerIdRoleMap[id]));
                myClueIdList = companyIdList.filter(id => !updateCustomerIdRoleMap[id] || ['myClue', 'colleagueClue', 'colleagueClueNoAuth'].includes(updateCustomerIdRoleMap[id]));
                openSeaClueIdList = companyIdList.filter(id => !updateCustomerIdRoleMap[id] || ['openSeaClue'].includes(updateCustomerIdRoleMap[id]));
            }
            const [myCustomerList, openSeaCustomerList, myClue, openSeaClue] = await Promise.all([
                myCompanyIdList.length ? this.doGetMyCustomerDataByIds(myCompanyIdList) : [],
                openSeaCompanyIdList.length ? this.doGetOpenSeaCustomerDataByIds(openSeaCompanyIdList) : [],
                myClueIdList.length ? this.getMyClueDataById(myClueIdList[0]) : null,
                openSeaClueIdList.length ? this.getOpenSeaClueDataById(openSeaClueIdList[0]) : null,
            ]);
            const customerList = [];
            myCustomerList.forEach(item => {
                customerList.push(Object.assign(Object.assign({}, item), { company_type: 'customer' }));
            });
            openSeaCustomerList.forEach(item => {
                customerList.push(Object.assign(Object.assign({}, item), { company_type: 'openSea' }));
            });
            if (myClue) {
                customerList.push(Object.assign(Object.assign({}, myClue), { company_type: 'clue' }));
            }
            if (openSeaClue) {
                customerList.push(Object.assign(Object.assign({}, openSeaClue), { company_type: 'clue' }));
            }
            return customerList;
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetCustomerDataByIds error', e);
            return [];
        }
    }
    async doGetMyCustomerDataByIds2(companyIdList) {
        var _a;
        try {
            if (!Array.isArray(companyIdList) || companyIdList.length === 0) {
                return [];
            }
            const customerViewRole = (_a = this.doGetLastEdmPrivilegeViewData()) === null || _a === void 0 ? void 0 : _a.customer;
            if (!customerViewRole) {
                console.warn('🚀 ~ MailPlusCustomer ~ doGetMyCustomerDataByIds 无客户权限');
                return [];
            }
            const url = this.systemApi.getUrl('getCustomerDetailBatch');
            const reqParams = {
                companyIdList,
            };
            const res = await this.httpApi.post(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                const { companyList = [] } = data;
                return companyList;
            }
            console.error('[mail_plus_customer] doGetCustomerDataByIds error', error);
            return [];
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetCustomerDataByIds error', e);
            return [];
        }
    }
    async getMyCustomerDataById(customerId) {
        try {
            const url = this.systemApi.getUrl('getCompanyDetailById');
            const reqParams = {
                customerId,
            };
            const res = await this.httpApi.get(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                return data;
            }
            console.error('[mail_plus_customer] getMyCustomerDataById error customerId', customerId, error);
        }
        catch (e) {
            console.error('[mail_plus_customer] getMyCustomerDataById error customerId', customerId, e);
        }
        return null;
    }
    async getMyClueDataById(clueId) {
        var _a;
        try {
            const clueViewRole = (_a = this.doGetLastEdmPrivilegeViewData()) === null || _a === void 0 ? void 0 : _a.clue;
            if (!clueViewRole) {
                console.warn('🚀 ~ MailPlusCustomer ~ getMyClueDataById 无线索权限');
                return null;
            }
            const url = this.systemApi.getUrl('getClueDetailById');
            const reqParams = {
                leadsId: clueId,
            };
            const res = await this.httpApi.get(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                return Object.assign(Object.assign({}, data), { company_name: data.company_name || data.leads_name, company_id: data.leads_id, company_number: data.leads_number, contact_list: [data.main_contact] });
            }
            console.error('[mail_plus_customer] getMyClueDataById error clueId', clueId, error);
        }
        catch (e) {
            console.error('[mail_plus_customer] getMyClueDataById error clueId', clueId, e);
        }
        return null;
    }
    async getOpenSeaClueDataById(clueId) {
        var _a;
        try {
            const openSeaClueViewRole = (_a = this.doGetLastEdmPrivilegeViewData()) === null || _a === void 0 ? void 0 : _a.openSeaClue;
            if (!openSeaClueViewRole) {
                console.warn('🚀 ~ MailPlusCustomer ~ getOpenSeaClueDataById 无公海线索权限');
                return null;
            }
            const url = this.systemApi.getUrl('getOpenSeaClueDetailById');
            const reqParams = {
                id: clueId,
            };
            const res = await this.httpApi.get(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                return Object.assign(Object.assign({}, data), { company_id: data.id, company_number: data.leads_number, originCompanyId: data.leads_id, contact_list: [data.main_contact] });
            }
            console.error('[mail_plus_customer] getOpenSeaClueDataById error clueId', clueId, error);
        }
        catch (e) {
            console.error('[mail_plus_customer] getOpenSeaClueDataById error clueId', clueId, e);
        }
        return null;
    }
    async doGetMyCustomerDataByIds(companyIdList) {
        var _a;
        try {
            if (!Array.isArray(companyIdList) || companyIdList.length === 0) {
                return [];
            }
            const customerViewRole = (_a = this.doGetLastEdmPrivilegeViewData()) === null || _a === void 0 ? void 0 : _a.customer;
            if (!customerViewRole) {
                console.warn('🚀 ~ MailPlusCustomer ~ doGetMyCustomerDataByIds 无客户权限');
                return [];
            }
            if (companyIdList.length > 6) {
                this.dataTrackApi.track('pc_getMyCustomerDataByIds_max_limit_error');
                console.warn('🚀 ~ MailPlusCustomer ~ doGetMyCustomerDataByIds ~ companyIdList个数过长');
            }
            const requests = lodashChunk(companyIdList, 3);
            const requesetPromise = requests.reduce(async (promise, ids, index) => {
                if (index !== 0) {
                    await wait(300);
                }
                const res = await promise;
                const promiseList = [];
                ids.forEach(id => {
                    if (id) {
                        promiseList.push(this.getMyCustomerDataById(id));
                    }
                });
                const list = await Promise.all(promiseList);
                res.push(...list);
                return res;
            }, Promise.resolve([]));
            const serverList = await requesetPromise;
            const resData = [];
            serverList.forEach(item => {
                if (item !== null) {
                    resData.push(item);
                }
            });
            return resData;
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetCustomerDataByIds error', e);
            return [];
        }
    }
    async doGetOpenSeaCustomerDataByIds(ids) {
        var _a;
        try {
            if (!Array.isArray(ids) || ids.length === 0) {
                return [];
            }
            const openSeaCustomerViewRole = (_a = this.doGetLastEdmPrivilegeViewData()) === null || _a === void 0 ? void 0 : _a.openSeaCustomer;
            if (!openSeaCustomerViewRole) {
                console.warn('🚀 ~ MailPlusCustomer ~ doGetMyCustomerDataByIds ~ 无公海客户权限');
                return [];
            }
            const url = this.systemApi.getUrl('getOpenSeaCustomerDetailBatch');
            const reqParams = {
                ids,
            };
            const res = await this.httpApi.post(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                if (Array.isArray(data)) {
                    return data.map(item => (Object.assign(Object.assign({}, item), { originCompanyId: item.company_id, company_id: item.id })));
                }
            }
            console.error('[mail_plus_customer] doGetOpenSeaCustomerDataByIds error', error);
            return [];
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetOpenSeaCustomerDataByIds error', e);
            return [];
        }
    }
    getCurrentContactId() {
        var _a, _b;
        const user = this.systemApi.getCurrentUser();
        return ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || ((_b = user === null || user === void 0 ? void 0 : user.prop) === null || _b === void 0 ? void 0 : _b.contactId);
    }
    doGetCustomerRoleByModel(model) {
        var _a, _b, _c, _d;
        const { manager_list: managerList, company_type } = model;
        if (company_type === 'customer' || company_type === 'openSea') {
            if (!(managerList === null || managerList === void 0 ? void 0 : managerList.length)) {
                return 'openSeaCustomer';
            }
            const managerIdsMap = util.listToMap(managerList, 'id');
            const contactId = this.getCurrentContactId();
            if (contactId && managerIdsMap[contactId]) {
                return 'myCustomer';
            }
            if ((_a = this.lastEdmPrivilegeRangeData) === null || _a === void 0 ? void 0 : _a.customer) {
                const hasAuth = (_b = this.lastEdmPrivilegeRangeData) === null || _b === void 0 ? void 0 : _b.customer.some(v => managerIdsMap[v]);
                return hasAuth ? 'colleagueCustomer' : 'colleagueCustomerNoAuth';
            }
            return 'colleagueCustomer';
        }
        if (!(managerList === null || managerList === void 0 ? void 0 : managerList.length)) {
            return 'openSeaClue';
        }
        const managerIdsMap = util.listToMap(managerList, 'id');
        const contactId = this.getCurrentContactId();
        if (contactId && managerIdsMap[contactId]) {
            return 'myClue';
        }
        if ((_c = this.lastEdmPrivilegeRangeData) === null || _c === void 0 ? void 0 : _c.clue) {
            const hasAuth = (_d = this.lastEdmPrivilegeRangeData) === null || _d === void 0 ? void 0 : _d.clue.some(v => managerIdsMap[v]);
            return hasAuth ? 'colleagueClue' : 'colleagueClueNoAuth';
        }
        return 'colleagueClue';
    }
    doSetLastEdmPrivilegeData(params) {
        var _a, _b;
        const { privilegeMap, contactPrivilegeRangeData, cluePrivilegeRangeData } = params;
        if (privilegeMap) {
            this.lastEdmPrivilegeViewData = this.edmRoleApi.doGetMailPlusEdmViewPrivilege();
        }
        if (contactPrivilegeRangeData) {
            this.lastEdmPrivilegeRangeData = {
                customer: this.edmRoleApi.doGetContactPrivilegeRangeData(),
                clue: (_a = this.lastEdmPrivilegeRangeData) === null || _a === void 0 ? void 0 : _a.clue,
            };
        }
        if (cluePrivilegeRangeData) {
            this.lastEdmPrivilegeRangeData = {
                clue: this.edmRoleApi.doGetCluePrivilegeRangeData(),
                customer: (_b = this.lastEdmPrivilegeRangeData) === null || _b === void 0 ? void 0 : _b.customer,
            };
        }
        console.log('[mail plus customer] role', this.lastEdmPrivilegeViewData, this.lastEdmPrivilegeRangeData);
    }
    doGetLastEdmPrivilegeViewData() {
        if (!this.lastEdmPrivilegeViewData) {
            this.doSetLastEdmPrivilegeData({ privilegeMap: new Map() });
        }
        return this.lastEdmPrivilegeViewData;
    }
    async doGetCustomerListFromServer(params) {
        var _a;
        const viewRole = (_a = this.doGetLastEdmPrivilegeViewData()) === null || _a === void 0 ? void 0 : _a.customer;
        if (!viewRole) {
            return [];
        }
        try {
            const url = this.systemApi.getUrl('getCustomerListPage');
            const res = await this.httpApi.post(url, params, {
                contentType: 'json',
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                const { companyList = [] } = data;
                return companyList;
            }
            console.error('[mail_plus_customer] doGetCustomerListFromServer error', error);
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetCustomerListFromServer catch error', e);
        }
        return [];
    }
    async doSearchCustomerPage(params) {
        const { keyword, pageSize = 20, page = 1, viewType = 'MY_CUSTOMER', filterEmptyCustomer, condition } = params;
        const url = viewType === 'MY_CUSTOMER' ? this.systemApi.getUrl('searchMyCustomer') : this.systemApi.getUrl('searchAllCustomer');
        let req = {
            page,
            page_size: pageSize,
        };
        if (condition === null || condition === void 0 ? void 0 : condition.length) {
            req = Object.assign(Object.assign({}, req), { quickFilter: {
                    relation: 'AND',
                    subs: condition,
                } });
        }
        else if (keyword) {
            req = Object.assign(Object.assign({}, req), { fuzzySearch: keyword, filter: filterEmptyCustomer
                    ? {
                        relation: 'AND',
                        subs: [
                            {
                                id: 'email',
                                table: 'customer_contact',
                                condition: {
                                    method: 'IS_NOT_EMPTY',
                                    value: null,
                                    values: null,
                                    type: null,
                                    current_user_in_values: false,
                                },
                            },
                        ],
                    }
                    : undefined });
        }
        else {
            return Promise.reject(new Error('[doSearchCustomerPage] keyword & condition is null'));
        }
        const { data } = await this.httpApi.post(url, req, {
            contentType: 'json',
        });
        if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
            const arr = (data.data.content || []).map(v => {
                var _a;
                const managerList = [];
                (_a = v.manager_list) === null || _a === void 0 ? void 0 : _a.forEach(manager => {
                    managerList.push({
                        managerId: manager.id,
                        managerAccount: manager.email,
                        managerName: manager.name,
                        iconUrl: manager.iconUrl,
                        lastMailTime: manager.lastMailTime,
                        managerOriginName: manager.manager_name,
                    });
                });
                return {
                    customerId: v.company_id,
                    customerName: v.company_name,
                    customerCreateTime: v.create_time || 0,
                    managerList,
                };
            });
            return {
                data: arr,
                pageSize: data.data.page_size,
                pageNum: data.data.page,
                totalSize: data.data.total_size,
                totalNum: data.data.total_page,
            };
        }
        return Promise.reject(new Error('[doSearchCustomerPage] return error'));
    }
    async doSearchCustomerAndContact(keyword, module, limit = 300) {
        const result = {
            customerList: [],
            customerContactList: [],
        };
        const lastEdmPrivilegeViewData = this.doGetLastEdmPrivilegeViewData();
        if (!(lastEdmPrivilegeViewData && lastEdmPrivilegeViewData.customer)) {
            return result;
        }
        if (keyword) {
            const url = this.systemApi.getUrl('searchMyCustomerAndContact');
            const req = {
                keyword,
                limit,
                module,
            };
            const { data } = await this.httpApi.post(url, req, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
                const customerList = data.data.customer_list;
                if (Array.isArray(customerList) && customerList.length > 0) {
                    result.customerList = customerList.map(v => ({
                        customerId: String(v.company_id),
                        customerName: v.company_name,
                        customerCreateTime: v.create_time || 0,
                        managerList: [],
                    }));
                }
                const contactList = data.data.contact_list;
                if (Array.isArray(contactList) && contactList.length > 0) {
                    result.customerContactList = contactList.map(v => ({
                        customerId: String(v.company_id),
                        contactId: String(v.contact_id),
                        contactName: v.contact_name,
                        contactEmail: v.contact_email,
                        contactCreateTime: v.create_time || 0,
                    }));
                }
            }
        }
        return result;
    }
    async doGetOpportunityByCompany(page = 1, size = 20, companyId, status) {
        if (!companyId) {
            return Promise.reject(new Error('[doGetOpportunityByCompany] company_id is null'));
        }
        try {
            const url = this.systemApi.getUrl('getOpportunityByCompany');
            const params = { page, size, company_id: companyId };
            if (Array.isArray(status) && status.length) {
                params.status = status;
            }
            const { data } = await this.httpApi.get(url, params);
            if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
                if (Array.isArray(data.data.content) && !!data.data.content.length) {
                    const arr = data.data.content;
                    return {
                        data: arr,
                        pageSize: data.data.page_size,
                        pageNum: data.data.page,
                        totalSize: data.data.total_size,
                        totalNum: data.data.total_page,
                    };
                }
                return {
                    data: [],
                    pageSize: data.data.page_size,
                    pageNum: data.data.page,
                    totalSize: data.data.total_size,
                    totalNum: data.data.total_page,
                };
            }
            return {
                data: [],
                pageSize: 20,
                pageNum: 1,
                totalSize: 0,
                totalNum: 0,
            };
        }
        catch (error) {
            console.log('[doGetOpportunityByCompany] err:', error);
            return {
                data: [],
                pageSize: 20,
                pageNum: 1,
                totalSize: 0,
                totalNum: 0,
            };
        }
    }
    async doGetOpportunityStatus() {
        const url = this.systemApi.getUrl('getOpportunityStatus');
        const { data } = await this.httpApi.get(url, { table: 'customer_opportunity' });
        if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
            return data.data;
        }
        return Promise.reject(new Error('[doGetOpportunityByCompany] error'));
    }
    async doGetClueStatus(table) {
        var _a, _b;
        const url = this.systemApi.getUrl('getClueFieldInfo');
        const { data } = await this.httpApi.get(url, { table });
        if ((data === null || data === void 0 ? void 0 : data.success) && data.data) {
            if ((_a = data.data) === null || _a === void 0 ? void 0 : _a.fields.length) {
                const result = {};
                (_b = data.data) === null || _b === void 0 ? void 0 : _b.fields.forEach((i) => {
                    var _a;
                    result[i.field_id] = ((_a = JSON.parse(i.config)) === null || _a === void 0 ? void 0 : _a.items) || [];
                });
                return result;
            }
            Promise.reject(new Error('[doGetClueStatus] error'));
        }
        return Promise.reject(new Error('[doGetClueStatus] error'));
    }
    async doGetContactListByCompanyId(params) {
        const { emailRole } = params, data = __rest(params, ["emailRole"]);
        let res = {
            success: false,
            totalSize: 0,
            page: 1,
            data: [],
        };
        switch (emailRole) {
            case 'myCustomer':
            case 'colleagueCustomer':
                res = await this.doGetContactListFromCustomer(data);
                break;
            case 'openSeaCustomer':
                res = await this.doGetContactListFromOpenSea(data);
                break;
            case 'myClue':
            case 'colleagueClue':
            case 'openSeaClue':
                res = await this.doGetClueContactList(data);
                break;
            default:
                console.error(`暂不支持${emailRole}类型的查询`);
        }
        return res;
    }
    async doGetContactListFromOpenSea(params) {
        var _a;
        try {
            const { page = 1, pageSize = 10, id } = params;
            if (pageSize > 500) {
                throw new Error('最大只能500!!');
            }
            const url = this.systemApi.getUrl('getOpenSeaCustomerList');
            const reqParams = {
                condition: '',
                customer_open_sea_id: id,
                page,
                page_size: pageSize,
            };
            const res = await this.httpApi.post(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, error, message } = res.data || {};
            if (success && (data === null || data === void 0 ? void 0 : data.content)) {
                if (Array.isArray(data.content)) {
                    return {
                        success: true,
                        totalSize: data.total_size,
                        page,
                        data: data.content,
                    };
                }
            }
            console.error('🚀 ~ MailPlusCustomer ~ doGetContactListFromOpenSea ~ error:', error);
            return {
                success: false,
                totalSize: 0,
                data: [],
                message,
                error,
                page,
            };
        }
        catch (error) {
            console.error('🚀 ~ MailPlusCustomer ~ doGetContactListFromOpenSea ~ error:', error);
            return {
                success: false,
                totalSize: 0,
                page: 1,
                data: [],
                message: (_a = error) === null || _a === void 0 ? void 0 : _a.message,
            };
        }
    }
    async doGetContactListFromCustomer(params) {
        var _a;
        try {
            const { page = 1, pageSize = 10, id, filterEmptyContact, excludeEmptyEmail } = params;
            if (pageSize > 500) {
                throw new Error('最大只能500!!');
            }
            const url = this.systemApi.getUrl('getCompanyCustomerList');
            const reqParams = {
                company_id: id,
                exclude_empty_email: excludeEmptyEmail,
                search_request: {
                    page,
                    page_size: pageSize,
                    filter: filterEmptyContact
                        ? {
                            relation: 'AND',
                            subs: [
                                {
                                    id: 'email',
                                    table: 'customer_contact',
                                    condition: {
                                        method: 'IS_NOT_EMPTY',
                                        value: null,
                                        values: null,
                                        type: null,
                                        current_user_in_values: false,
                                    },
                                },
                            ],
                        }
                        : undefined,
                },
            };
            const res = await this.httpApi.post(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, code, message, total } = res.data || {};
            if (success && data) {
                if (Array.isArray(data)) {
                    return {
                        success: true,
                        totalSize: total,
                        page,
                        data: data,
                    };
                }
            }
            console.error('🚀 ~ MailPlusCustomer ~ doGetContactListFromCustomer ~ error:', message);
            return {
                success: false,
                totalSize: 0,
                page,
                data: [],
                message,
                error: code,
            };
        }
        catch (error) {
            console.error('🚀 ~ MailPlusCustomer ~ doGetContactListFromCustomer ~ error:', error);
            return {
                success: false,
                totalSize: 0,
                page: 1,
                data: [],
                message: (_a = error) === null || _a === void 0 ? void 0 : _a.message,
            };
        }
    }
    async doGetClueContactList(params) {
        var _a;
        try {
            const { page = 1, pageSize = 10, id, excludeEmptyEmail } = params;
            if (pageSize > 500) {
                throw new Error('最大只能500!!');
            }
            const url = this.systemApi.getUrl('getClueContactList');
            const reqParams = {
                leads_id: id,
                exclude_empty_email: excludeEmptyEmail,
                search_request: {
                    page,
                    page_size: pageSize,
                },
            };
            const res = await this.httpApi.post(url, reqParams, {
                contentType: 'json',
            });
            const { success, data, code, message, total } = res.data || {};
            if (success && data) {
                if (Array.isArray(data)) {
                    return {
                        success: true,
                        totalSize: total,
                        page,
                        data: data,
                    };
                }
            }
            console.error('🚀 ~ MailPlusCustomer ~ doGetContactListFromCustomer ~ error:', message);
            return {
                success: false,
                totalSize: 0,
                page,
                data: [],
                message,
                error: code,
            };
        }
        catch (error) {
            console.error('🚀 ~ MailPlusCustomer ~ doGetContactListFromCustomer ~ error:', error);
            return {
                success: false,
                totalSize: 0,
                page: 1,
                data: [],
                message: (_a = error) === null || _a === void 0 ? void 0 : _a.message,
            };
        }
    }
    doGetDisplayEmailLabelMap() {
        return this.displayEmailLabelMap;
    }
    doUpdateDisplayEmailLabelMap(params) {
        const { email, _account, name = email, action = 'add' } = params;
        const emailMap = this.displayEmailLabelMap.get(_account) || new Map();
        if (action === 'add' && !emailMap.has(email)) {
            emailMap.set(email, name);
        }
        else if (action === 'delete' && emailMap.has(email)) {
            emailMap.delete(email);
        }
        this.displayEmailLabelMap.set(_account, emailMap);
    }
    async doGetReplyMark(mid) {
        const url = this.systemApi.getUrl('EdmReplyMark');
        try {
            const res = await this.httpApi.get(url, { mid }, {
                contentType: 'json',
            });
            const { success, data } = res.data || {};
            if (success && data) {
                return { visible: data.visible || false };
            }
            return { visible: false };
        }
        catch (error) {
            console.log('MailPlusCustomer doGetReplyMark error:', error);
            return { visible: false };
        }
    }
    async doGetReplyMarkConfirm(mid, valid) {
        const url = this.systemApi.getUrl('EdmReplyMarkConfirm');
        const reqParams = {
            mid,
            valid,
        };
        try {
            const res = await this.httpApi.post(url, reqParams, {
                contentType: 'json',
            });
            return res;
        }
        catch (error) {
            console.log('MailPlusCustomer doGetReplyMarkConfirm error:', error);
        }
    }
    async edmReplyMarkFeedback(params) {
        const url = this.systemApi.getUrl('edmReplyMarkFeedback');
        try {
            const res = await this.httpApi.post(url, params, {
                contentType: 'json',
            });
            return res.data;
        }
        catch (error) {
            console.log('MailPlusCustomer edmReplyMarkFeedback error:', error);
        }
        return false;
    }
    async edmValidReplyMarkFeedback(params) {
        const url = this.systemApi.getUrl('edmValidReplyMarkFeedback');
        try {
            const res = await this.httpApi.post(url, params, {
                contentType: 'json',
            });
            return res.data;
        }
        catch (error) {
            console.log('MailPlusCustomer edmValidReplyMarkFeedback error:', error);
        }
        return false;
    }
    async getMyCustomerGroupLevel1List(viewType = 'MY_CUSTOMER') {
        try {
            const url = this.systemApi.getUrl('getCustomerGroup1List');
            const res = await this.httpApi.get(url, {
                type: 'CUSTOMER',
                viewType,
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                return data.map(item => {
                    var _a;
                    return (Object.assign(Object.assign({}, item), { id: item.group_id, name: item.group_name, hasChildren: item.has_second_level_group, requestParams: {
                            groupedFilter: (_a = item.first_level_group_filter_settings) === null || _a === void 0 ? void 0 : _a.grouped_filter,
                        } }));
                });
            }
            console.error('[mail_plus_customer] getMyCustomerGroupLevel1List error', error);
        }
        catch (e) {
            console.error('[mail_plus_customer] getMyCustomerGroupLevel1List error', e);
        }
        return [];
    }
    async getMyCustomerGroupLevel2List(id, viewType = 'MY_CUSTOMER') {
        if (id === MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT) {
            return this.latestContactIdList.map(code => {
                const item = this.latestContactGroups[code];
                return {
                    id: id + '_' + item.group_id,
                    name: item.group_name,
                    count: item.count,
                    hasChildren: item.count > 0,
                    requestParams: {
                        groupedFilter: item.filter,
                        group_code: code,
                    },
                };
            });
        }
        try {
            const url = this.systemApi.getUrl('getCustomerGroup2List');
            const res = await this.httpApi.get(url, {
                group_id: id,
                viewType,
            });
            const { success, data, error } = res.data || {};
            if (success && data) {
                return data.map(item => ({
                    id: id + '_' + item.group_name,
                    name: item.group_name,
                    count: item.count,
                    hasChildren: item.count > 0,
                    requestParams: {
                        groupedFilter: item.group_filter,
                        secondGroupedFilter: item.second_group_filter,
                    },
                }));
            }
            console.error('[mail_plus_customer] getMyCustomerGroupLevel2List error', id, error);
        }
        catch (e) {
            console.error('[mail_plus_customer] getMyCustomerGroupLevel2List error', e);
        }
        return [];
    }
    async doGetMyCustomerGroupList(params) {
        const { level, id, viewType } = params;
        if (level === 1) {
            return this.getMyCustomerGroupLevel1List(viewType);
        }
        if (!id) {
            return [];
        }
        return this.getMyCustomerGroupLevel2List(id, viewType);
    }
    async doGetMyCustomerByGroup(params) {
        const { page, pageSize, requestParams, filterEmptyCustomer, viewType = 'MY_CUSTOMER' } = params;
        try {
            const url = viewType === 'MY_CUSTOMER' ? this.systemApi.getUrl('getMyCustomerListByGroup') : this.systemApi.getUrl('getAllCustomerListByGroup');
            const res = await this.httpApi.post(url, {
                page,
                page_size: pageSize,
                groupedFilter: requestParams === null || requestParams === void 0 ? void 0 : requestParams.groupedFilter,
                secondGroupedFilter: requestParams === null || requestParams === void 0 ? void 0 : requestParams.secondGroupedFilter,
                group_code: requestParams === null || requestParams === void 0 ? void 0 : requestParams.group_code,
                filter: filterEmptyCustomer
                    ? {
                        relation: 'AND',
                        subs: [
                            {
                                id: 'email',
                                table: 'customer_contact',
                                condition: {
                                    method: 'IS_NOT_EMPTY',
                                    value: null,
                                    values: null,
                                    type: null,
                                    current_user_in_values: false,
                                },
                            },
                        ],
                    }
                    : undefined,
            }, {
                contentType: 'json',
            });
            const { data, success } = res.data || {};
            if (success && data) {
                return {
                    page: data.page,
                    pageSize: data.page_size,
                    totalPage: data.total_page,
                    totalSize: data.total_size,
                    data: data.content || [],
                };
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetMyCustomerByGroup error', e);
        }
        return {
            page,
            pageSize: pageSize || 0,
            totalPage: 0,
            totalSize: 0,
            data: [],
        };
    }
    async doGetEdmCustomer(params) {
        const url = this.systemApi.getUrl('getEdmCustomer');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { data, success } = res.data || {};
        if (success && data) {
            return data;
        }
        throw new Error();
    }
    async getEdmLeads(params) {
        const url = this.systemApi.getUrl('getEdmLeads');
        const res = await this.httpApi.post(url, params, {
            contentType: 'json',
        });
        const { data, success } = res.data || {};
        if (success && data) {
            return data;
        }
        throw new Error();
    }
    async doGetMyCustomerGroup1Count(id) {
        try {
            if (!id) {
                return 0;
            }
            const url = this.systemApi.getUrl('getCustomerGroup1CountList');
            const ret = await this.httpApi.get(url, {
                group_id: id,
                viewType: 'MY_CUSTOMER',
            });
            const { success, data } = ret.data || {};
            if (success && data) {
                return data;
            }
            return 0;
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetMyCustomerGroup1CountList error', e);
        }
        return 0;
    }
    async doGetMyCustomerGroup1CountList(idList, viewType = 'MY_CUSTOMER') {
        try {
            if (!idList || idList.length === 0) {
                return {};
            }
            const url = this.systemApi.getUrl('getCustomerGroup1CountListBatch');
            const [totalSize, latestContactSize, favoriteCount, monitorCount, list] = await Promise.all([
                this.doGetMyCustomerByGroup({ page: 1, pageSize: 1, viewType }).then(res => res.totalSize),
                this.getLatestContactGroupCount(viewType),
                this.getGroupCountByFilter(this.groupsFilters[MAIL_PLUS_CUSTOMER_GROUP_FAVORITE], viewType),
                this.getGroupCountByFilter(this.groupsFilters[MAIL_PLUS_CUSTOMER_GROUP_MONITOR], viewType),
                this.httpApi.post(url, { group_ids: idList, viewType }, { contentType: 'json' }).then(({ data }) => {
                    if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                        return data.data;
                    }
                    return [];
                }),
            ]);
            const res = list.reduce((obj, item) => {
                if (item === null || item === void 0 ? void 0 : item.group_id) {
                    obj[item.group_id] = item.count;
                }
                return obj;
            }, {
                ALL: totalSize,
                [MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT]: latestContactSize,
                [MAIL_PLUS_CUSTOMER_GROUP_FAVORITE]: favoriteCount,
                [MAIL_PLUS_CUSTOMER_GROUP_MONITOR]: monitorCount,
            });
            return res;
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetMyCustomerGroup1CountList error', e);
        }
        return {};
    }
    async doGetNewCustomsList(_params) {
        var _a;
        const { type, size = 20 } = _params, params = __rest(_params, ["type", "size"]);
        try {
            const url = type === 'buyers' ? this.systemApi.getUrl('diffGlobalSuppliersBuyers') : this.systemApi.getUrl('diffGlobalBuyersSuppliers');
            const param = Object.assign(Object.assign({}, params), { size });
            const res = await this.httpApi.post(url, Object.assign(Object.assign({}, param), getSignByApiParams(param)), { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                const nextFrom = +(data.from || 0) + 1;
                return {
                    from: data.from,
                    size: data.size,
                    total: data.total,
                    nextFrom,
                    hasMore: data.total > nextFrom * size,
                    data: (_a = data.companies) === null || _a === void 0 ? void 0 : _a.map(this.mailPlusUtilInstance.formatterServerCustoms),
                };
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetCustomsList error', error);
        }
        return {
            from: params.from,
            size: 0,
            total: 0,
            nextFrom: 0,
            hasMore: false,
            data: [],
        };
    }
    async doGetCustomsList(_params) {
        var _a;
        const { type, size = 20 } = _params, params = __rest(_params, ["type", "size"]);
        try {
            const url = type === 'buyers' ? this.systemApi.getUrl('getCustomsListByBuyers') : this.systemApi.getUrl('getCustomsListBySuppliers');
            const param = Object.assign(Object.assign({}, params), { size });
            const res = await this.httpApi.get(url, Object.assign(Object.assign({}, param), getSignByApiParams(param)), { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                const nextFrom = +(data.from || 0) + 1;
                return {
                    from: data.from,
                    size: data.size,
                    total: data.total,
                    nextFrom,
                    hasMore: data.total > nextFrom * size,
                    data: (_a = data.companies) === null || _a === void 0 ? void 0 : _a.map(this.mailPlusUtilInstance.formatterServerCustoms),
                };
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetCustomsList error', error);
        }
        return {
            from: params.from,
            size: 0,
            total: 0,
            nextFrom: 0,
            hasMore: false,
            data: [],
        };
    }
    async getEnterpriseWhatsAppMember(params) {
        try {
            const res = await this.httpApi.get(this.systemApi.getUrl('getEnterpriseWhatsAppMember'), params, {
                contentType: 'json',
            });
            const { data, success } = res.data || {};
            if (success && data && data.from) {
                const list = data.from.map(this.mailPlusUtilInstance.formatterServerEnterpriseWhatsAppMember);
                const noAvatarIdSet = list.reduce((ids, item) => {
                    if (!item.avatarUrl) {
                        ids.add(item.accountId);
                    }
                    return ids;
                }, new Set());
                if (noAvatarIdSet.size) {
                    const contactList = await this.contactApi.doGetContactById([...noAvatarIdSet]);
                    const idAvatarMap = lodashKeyBy(contactList, 'contact.id');
                    list.forEach(item => {
                        var _a, _b;
                        if (noAvatarIdSet.has(item.accountId)) {
                            const avatar = ((_b = (_a = idAvatarMap[item.accountId]) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.avatar) || '';
                            item.avatarUrl = avatar;
                        }
                    });
                }
                return list;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] getEnterpriseWhatsAppMember error', error);
        }
        return [];
    }
    async getEnterpriseWhatsAppFromToMember(params) {
        try {
            const typeEnum = { 1: 'CUSTOMER', 2: 'LEADS', 3: 'OPPORTUNITY', 4: 'CONTACT' };
            const type = (params === null || params === void 0 ? void 0 : params.type) ? typeEnum[params.type] : undefined;
            const res = await this.httpApi.post(this.systemApi.getUrl('getEnterpriseWhatsAppFromToMember'), Object.assign(Object.assign({}, params), { type }), {
                contentType: 'json',
            });
            const { data, success } = res.data || {};
            if (success && data && data.length) {
                const list = data.map(this.mailPlusUtilInstance.formatterWAServerEnterpriseWhatsAppMember);
                return list;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] getEnterpriseWhatsAppMember error', error);
        }
        return [];
    }
    async getPersonalWhatsAppMember(params) {
        try {
            const typeEnum = { 1: 'CUSTOMER', 2: 'LEADS', 3: 'OPPORTUNITY', 4: 'CONTACT' };
            const type = (params === null || params === void 0 ? void 0 : params.type) ? typeEnum[params.type] : undefined;
            const res = await this.httpApi.post(this.systemApi.getUrl('getPersonalWhatsAppMember'), { resourceId: params.resourceId, type }, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                return data.map(this.mailPlusUtilInstance.formatterServerPersonalWhatsAppMember);
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] getPersonalWhatsAppMember error', error);
        }
        return [];
    }
    async getPersonalWhatsAppMemberByUserId(params) {
        try {
            const res = await this.httpApi.post(this.systemApi.getUrl('getPersonalWhatsAppMemberByUserId'), { userId: params.from + '@c.us', chatId: params.to + '@c.us' }, { contentType: 'form' });
            const { data, success } = res.data || {};
            if (success && data) {
                return data.map(item => this.mailPlusUtilInstance.formatterWAServerPersonalWhatsAppMember(item, params.to));
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] getPersonalWhatsAppMember error', error);
        }
        return [];
    }
    async doGetEnterpriseWhatsAppToMember(params) {
        try {
            const res = await this.httpApi.get(this.systemApi.getUrl('getEnterpriseWhatsAppToMember'), params, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data && data.to) {
                return data.to.map(item => item.whatsApp);
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetWhatsAppEnterpriseToMember error', error);
        }
        return [];
    }
    async doGetWhatsAppMember(params) {
        try {
            const [enterpriseData, personalData] = await Promise.all([this.getEnterpriseWhatsAppFromToMember(params), this.getPersonalWhatsAppMember(params)]);
            return [...enterpriseData, ...personalData];
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetWhatsAppMember error', error);
        }
        return [];
    }
    async doGetWhatsAppMemberWithoutResourceId(params) {
        try {
            if (!params.isBsp) {
                const [enterpriseData, personalData] = await Promise.all([this.getEnterpriseWhatsAppFromToMember(params), this.getPersonalWhatsAppMemberByUserId(params)]);
                return [...enterpriseData, ...personalData];
            }
            const enterpriseData = await this.getEnterpriseWhatsAppFromToMember(params);
            return enterpriseData;
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetWhatsAppMember error', error);
        }
        return [];
    }
    async doSearchWhatsAppMsg(_params) {
        const { type } = _params, params = __rest(_params, ["type"]);
        try {
            if (type === 'enterprise') {
                const res = await this.httpApi.post(this.systemApi.getUrl('searchEnterpriseWhatsAppMsg'), Object.assign({}, params), { contentType: 'json' });
                const { data, success } = res.data || {};
                if (success && data) {
                    return data.content.map(item => this.mailPlusUtilInstance.formatterServerEnterpriseWhatsAppMsg(item, params.from));
                }
            }
            else {
                const body = {
                    fromAccId: params.accountId,
                    fromNumber: params.from,
                    searchContent: params.searchContent,
                    toNumber: params.to,
                };
                const res = await this.httpApi.get(this.systemApi.getUrl('searchPersonalWhatsAppMsg'), body, { contentType: 'json' });
                const { data, success } = res.data || {};
                if (success && data && data.content) {
                    return data.content.map(this.mailPlusUtilInstance.formatterServerPersonalWhatsAppMsg);
                }
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doSearchWhatsAppMsg error', error);
        }
        return [];
    }
    async doGetDiscoveryData(params) {
        try {
            const res = await this.httpApi.post(this.systemApi.getUrl('getDiscoveryData'), params, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                return data;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetDiscoveryData error', error);
        }
        return null;
    }
    async doGetDiscoverTabReadTime(id) {
        try {
            const res = await this.httpApi.get(this.systemApi.getUrl('getDiscoverTabReadTime'), { company_id: id }, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                return data;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetDiscoverTabReadTime error', error);
        }
        return 0;
    }
    async doSetDiscoverTabReadTime(params) {
        try {
            const res = await this.httpApi.post(this.systemApi.getUrl('setDiscoverTabReadTime'), {
                biz_id: params.id,
                read_time: params.time,
            }, { contentType: 'json' });
            const { success } = res.data || {};
            if (success) {
                return true;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doSetDiscoverTabReadTime error', error);
        }
        return false;
    }
    async doGetContactDetail(params) {
        try {
            const res = await this.httpApi.get(this.systemApi.getUrl('getCustomerContactDetailById'), {
                contact_id: params.contactId,
                company_id: params.resourceId,
            }, { contentType: 'json' });
            const { success, data } = res.data || {};
            if (success && data) {
                return data;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetContactDetail error', error);
        }
        return null;
    }
    async doSetUnreadReplyNotify(_targetEmail, days) {
        var _a, _b;
        const targetEmail = ((_a = this.systemApi.getCurrentUser(_targetEmail)) === null || _a === void 0 ? void 0 : _a.agentEmail) || ((_b = this.systemApi.getCurrentUser(_targetEmail)) === null || _b === void 0 ? void 0 : _b.loginAccount) || _targetEmail;
        try {
            const url = this.systemApi.getUrl('unreadReplyNotify');
            const res = await this.httpApi.post(url, {
                targetEmail,
                days: days || 3,
            }, {
                contentType: 'json',
            });
            const { data, success } = res.data || {};
            if (success && data) {
                return Promise.resolve(true);
            }
            return Promise.resolve(false);
        }
        catch (e) {
            console.error('[mail_plus_customer] doSetUnreadReplyNotify error', e);
            return Promise.resolve(false);
        }
    }
    async doGetColleagueRelationList(colleagueAccId) {
        try {
            const res = await this.httpApi.get(this.systemApi.getUrl('getColleagueRelationList'), { colleagueAccId }, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                return data.map(this.mailPlusUtilInstance.formatterColleagueRelationList);
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetColleagueRelationList error', error);
        }
        return [];
    }
    async doGetAISuggestByEmail(email) {
        var _a;
        try {
            const from = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
            if (!from) {
                console.error('[mail_plus_customer] doGetAISuggestByEmail error no main account');
                return false;
            }
            const res = await this.httpApi.get(this.systemApi.getUrl('getAISuggestByEmail'), { from, to: email }, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && (data === null || data === void 0 ? void 0 : data.pop)) {
                return true;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetAISuggestByEmail error', error);
        }
        return false;
    }
    async doGetAISuggestByCustomer(info) {
        try {
            const res = await this.httpApi.get(this.systemApi.getUrl('getSuggetionPurchasesInfo'), info, { contentType: 'json' });
            const { data, success } = res.data || {};
            if (success && data) {
                return data;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetAISuggestByCustomer error', error);
        }
        return null;
    }
    async getLatestContactGroupCount(viewType) {
        try {
            const idList = this.latestContactIdList;
            const groups = this.latestContactGroups;
            const url = this.systemApi.getUrl('getGroupCountByFilter');
            const resIdCountMap = {};
            const promiseList = idList.map(id => this.httpApi
                .post(url, {
                filter: groups[id].filter,
                viewType,
                functionType: 'CUSTOMER',
            }, {
                contentType: 'json',
            })
                .then(({ data }) => {
                if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                    resIdCountMap[id] = data === null || data === void 0 ? void 0 : data.data;
                }
            }));
            await Promise.all(promiseList);
            let total = 0;
            idList.forEach(id => {
                const count = resIdCountMap[id] || 0;
                const item = groups[id];
                total += count;
                if (item) {
                    item.count = count;
                }
            });
            return total;
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetLatestContactGroupCount error', e);
        }
        return 0;
    }
    async getGroupCountByFilter(filter, viewType) {
        try {
            const url = this.systemApi.getUrl('getGroupCountByFilter');
            const { data } = await this.httpApi.post(url, {
                filter,
                viewType,
                functionType: 'CUSTOMER',
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return data.data;
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetGroupCountByFilter error', e);
        }
        return 0;
    }
    doGetGroupRequestParams(type) {
        return this.groupsFilters[type];
    }
    async doDeleteCustomerContact(company_id, contact_ids) {
        var _a;
        try {
            const url = this.systemApi.getUrl('deleteCustomerContactNew');
            const { data } = await this.httpApi.post(url, {
                company_id,
                contact_ids,
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return true;
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doDeleteCustomerContact error', e);
            return Promise.reject(new Error(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || '暂无权限'));
        }
        return false;
    }
    async doDeleteClueContact(company_id, contact_ids) {
        var _a;
        try {
            const url = this.systemApi.getUrl('deleteClueContactNew');
            const { data } = await this.httpApi.post(url, {
                leads_id: company_id,
                contact_ids,
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return true;
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doDeleteClueContact error', e);
            return Promise.reject(new Error(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || '暂无权限'));
        }
        return false;
    }
    async doSetProcessedOfFollow(midList, accounts, processed) {
        var _a;
        try {
            const url = this.systemApi.getUrl('setProcessedOfFollow');
            const { data } = await this.httpApi.post(url, {
                midList: midList.map((mid, idx) => {
                    return {
                        accEmail: accounts[idx],
                        mid,
                    };
                }),
                processed,
            }, {
                contentType: 'json',
            });
            if (data === null || data === void 0 ? void 0 : data.success) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doSetProcessedOfFollow error', e);
            return Promise.reject(new Error(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || '暂无权限'));
        }
    }
    async doGetMailStatusOfFollow(mid, account) {
        var _a;
        try {
            const url = this.systemApi.getUrl('getMailStatusOfFollow');
            const { data } = await this.httpApi.post(url, {
                accEmail: account,
                mid,
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return {
                    mid: data === null || data === void 0 ? void 0 : data.data.mid,
                    processed: data === null || data === void 0 ? void 0 : data.data.processed,
                };
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetMailStatusOfFollow error', e);
            return Promise.reject(new Error(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || '暂无权限'));
        }
        return { mid: '' };
    }
    async doGetColleagueUnFollowNumber(colleagueAccId, isMultiple, subEmails) {
        try {
            const url = this.systemApi.getUrl('getNumberOfSubUnFollow');
            const currentUser = this.systemApi.getCurrentUser();
            const reqParams = {
                multiple: isMultiple,
                sid: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '',
                node: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.node) || 'hz',
                colleagueId: colleagueAccId,
                subEmails,
            };
            const res = await this.httpApi.get(url, reqParams, {
                contentType: 'json',
            });
            const { success, data } = res.data || {};
            if (success && data) {
                return {
                    customerCount: data.customerCount || 0,
                    nonCustomerCount: data.nonCustomerCount || 0,
                };
            }
            return {
                customerCount: 0,
                nonCustomerCount: 0,
            };
        }
        catch (e) {
            console.error('[mail_plus_customer] doGetColleagueUnFollowNumber error customerId', e);
            return {
                customerCount: 0,
                nonCustomerCount: 0,
            };
        }
    }
    async doMarkAllProcessedOfFollow(accEmails, customerEmail) {
        try {
            const url = this.systemApi.getUrl('setAllProcessedl');
            const { data } = await this.httpApi.post(url, {
                accEmails,
                customerEmail,
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
            }
        }
        catch (e) {
        }
    }
    async doCheckEmailExists(belong_acc_id, main_acc_id, mid) {
        try {
            const url = this.systemApi.getUrl('checkEmailExists');
            const { data } = await this.httpApi.post(url, {
                belong_acc_id,
                main_acc_id,
                mid,
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return Promise.resolve(true);
            }
            else {
                return Promise.resolve(false);
            }
        }
        catch (e) {
            console.error('[mail_plus_customer] doCheckEmailExists error', e);
            return Promise.resolve(false);
        }
    }
    doGetEdmSendMailConflictConfig() {
        return this.edmSendMailConflictConfig;
    }
    async doGetEdmSendMailConflictConfigForce() {
        try {
            const url = this.systemApi.getUrl('getEdmSendMailConflictConfig');
            const { data } = await this.httpApi.get(url);
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                const config = data === null || data === void 0 ? void 0 : data.data;
                const list = (config === null || config === void 0 ? void 0 : config.length) > 0 ? config : defaultEdmSendMailConflictConfig;
                this.edmSendMailConflictConfig = list;
                return list;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] doGetEdmSendMailConflictConfigForce error', error);
        }
        return this.edmSendMailConflictConfig;
    }
    async updateEdmSendMailConflictConfig(config) {
        try {
            const url = this.systemApi.getUrl('updateEdmSendMailConflictConfig');
            const { data } = await this.httpApi.post(url, { items: config }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                return true;
            }
        }
        catch (error) {
            console.error('[mail_plus_customer] updateEdmSendMailConflictConfig error', error);
        }
        return false;
    }
}
const mailPlusCustomerApi = new MailPlusCustomer();
api.registerLogicalApi(mailPlusCustomerApi);
export default mailPlusCustomerApi;
